module.exports = __webpack_public_path__ + "img/class-group-sm.c514db41.png";